import React, { forwardRef } from "react";
import { formatDisplayDate } from "helpers/calendar/calendarDates";
import { downloadICS } from "helpers/calendar/calendarTerms";

const CalendarDayDetail = forwardRef(({ date, info, onClose }, ref) => {
  if (!date || !info) return null;

  const closedLabel = info.closureLabel || "Closed";

  const handleAddToCalendar = () => {
    let title = "Ace Gymnastics";
    if (info.isAutoDraft && info.isClosed) {
      title = `Ace Gymnastics — ${closedLabel} (Fee auto-draft)`;
    } else if (info.isAutoDraft) {
      title = "Ace Gymnastics — Fee auto-draft";
    } else if (info.isClosed) {
      title =
        closedLabel === "Closed"
          ? "Ace Gymnastics — Closed"
          : `Ace Gymnastics — Closed (${closedLabel})`;
    }

    downloadICS({
      title,
      date,
      description: info.term ? info.term.name : undefined,
    });
  };

  return (
    <aside ref={ref} className="calendar-detail" aria-live="polite">
      <div className="calendar-detail__header">
        <h3 className="calendar-detail__title">{formatDisplayDate(date)}</h3>
        <button
          type="button"
          className="calendar-detail__close"
          onClick={onClose}
          aria-label="Close day details"
        >
          ×
        </button>
      </div>

      <dl className="calendar-detail__meta">
        {info.term && (
          <>
            <dt>Term</dt>
            <dd>{info.term.name}</dd>
          </>
        )}
        {info.isClosed && (
          <>
            <dt>Closure</dt>
            <dd>{closedLabel}</dd>
          </>
        )}
        {info.isAutoDraft && (
          <>
            <dt>Billing</dt>
            <dd>Fee auto-draft date</dd>
          </>
        )}
        {!info.isClosed && !info.isAutoDraft && info.term && (
          <>
            <dt>Status</dt>
            <dd>Open</dd>
          </>
        )}
        {!info.term && (
          <>
            <dt>Status</dt>
            <dd>Outside scheduled terms</dd>
          </>
        )}
      </dl>

      {(info.isAutoDraft || info.isClosed) && (
        <button
          type="button"
          className="site-btn site-btn--accent calendar-detail__add"
          onClick={handleAddToCalendar}
        >
          Add to my calendar
        </button>
      )}
    </aside>
  );
});

CalendarDayDetail.displayName = "CalendarDayDetail";

export default CalendarDayDetail;
